<div class="flex items-center gap-8 w-full mb-24">
  <div class="relative flex flex-1" id="mach-core-flyout-search-input-wrapper">
    <input
      class="single-line-input w-icon peer w-full"
      id="mach-core-site-search-input"
      placeholder=" "
      [(ngModel)]="searchTerm"
      (input)="onSearchInput($event)"
      (focus)="onInputFocus()"
      (blur)="onInputBlur()"
      (keydown)="onKeydown($event)"
      (keydown.enter)="submitSearch()"
      [maxlength]="content.maxCharacterCount || 300"
      [attr.aria-label]="content.submitSearch.placeHolderText"
      role="combobox"
      aria-autocomplete="list"
      aria-controls="mach-core-flyout-search-autocomplete-list"
      [attr.aria-expanded]="showDropdown && autocompleteSuggestions.length > 0"
      autocomplete="off"
    />
    <label for="mach-core-site-search-input" class="floating-title">
      {{ content.submitSearch.placeHolderText }}
    </label>
    @if (searchTerm.length > 0) {
      <button
        class="absolute right-12 top-1/2 -translate-y-1/2 w-6 h-6 flex items-center justify-center !cursor-pointer"
        type="button"
        (click)="onClearSearch()"
        aria-label="Clear search"
        id="mach-core-flyout-search-clear-button"
      >
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 4L4 12M4 4L12 12"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
          />
        </svg>
      </button>
    }

    <!-- Autocomplete Dropdown -->
    @if (showDropdown && autocompleteSuggestions.length > 0) {
      <div
        class="absolute top-full left-0 right-0 mt-8 rounded-03 shadow-01 border border-stroke-01 z-50 overflow-hidden bg-surface-02"
        id="mach-core-flyout-search-autocomplete-list"
      >
        <div class="px-16 pt-12 pb-8">
          <span class="text-label-sm-semibold text-subtle">
            {{
              searchTerm.trim()
                ? content.suggestionsFilteredLabel || 'Suggestions'
                : content.suggestionsLabel || 'Popular questions'
            }}
          </span>
        </div>
        <ul
          class="max-h-[200px] tablet:max-h-[260px] overflow-y-auto pb-8"
          role="listbox"
        >
          @for (
            question of autocompleteSuggestions;
            track question;
            let i = $index
          ) {
            <li
              role="option"
              class="group flex items-center gap-12 px-16 py-12 cursor-pointer transition-colors duration-150 hover:bg-surface-03"
              (mousedown)="selectQuestion(question)"
              id="mach-core-flyout-search-autocomplete-item-{{ i }}"
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="flex-shrink-0 mt-2 text-subtle group-hover:text-heading transition-colors duration-150"
                aria-hidden="true"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M2.53564 7.61158C2.53564 4.96869 4.68637 2.81807 7.32939 2.81807C9.97241 2.81807 12.1231 4.96869 12.1231 7.61158C12.1231 10.2545 9.97241 12.4043 7.32939 12.4043C4.68637 12.4043 2.53564 10.2545 2.53564 7.61158ZM16.5938 16.0753L11.8968 11.3794C12.7442 10.3545 13.2535 9.04157 13.2535 7.61159C13.2535 4.34491 10.5959 1.6875 7.32985 1.6875C4.0638 1.6875 1.40625 4.34491 1.40625 7.61159C1.40625 10.8775 4.0638 13.5349 7.32985 13.5349C8.75991 13.5349 10.0729 13.0249 11.0979 12.1783L15.7948 16.875L16.5938 16.0753Z"
                  fill="currentColor"
                />
              </svg>
              <span
                class="text-body-copy group-hover:text-heading transition-colors duration-150 leading-tight"
              >
                {{ question }}
              </span>
            </li>
          }
        </ul>
      </div>
    }
  </div>
  <button
    class="button button-icon cursor-pointer flex-shrink-0 border-none !bg-transparent active:!bg-transparent hover:!bg-transparent"
    tabindex="0"
    role="button"
    aria-label="Search"
    (click)="submitSearch()"
    id="mach-core-flyout-search-submit-button"
  >
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2.53564 7.61158C2.53564 4.96869 4.68637 2.81807 7.32939 2.81807C9.97241 2.81807 12.1231 4.96869 12.1231 7.61158C12.1231 10.2545 9.97241 12.4043 7.32939 12.4043C4.68637 12.4043 2.53564 10.2545 2.53564 7.61158ZM16.5938 16.0753L11.8968 11.3794C12.7442 10.3545 13.2535 9.04157 13.2535 7.61159C13.2535 4.34491 10.5959 1.6875 7.32985 1.6875C4.0638 1.6875 1.40625 4.34491 1.40625 7.61159C1.40625 10.8775 4.0638 13.5349 7.32985 13.5349C8.75991 13.5349 10.0729 13.0249 11.0979 12.1783L15.7948 16.875L16.5938 16.0753Z"
        fill="#001E3C"
      />
    </svg>
  </button>
</div>

<div class="grid" id="mach-core-flyout-search-popular-section">
  <h2
    class="text-label-md-semibold text-heading mb-24"
    id="mach-core-flyout-search-popular-title"
  >
    {{ content.popularSearchTitle }}
  </h2>
  <ul class="grid gap-16" id="mach-core-flyout-search-popular-list">
    @for (topic of content.contentPopularSearch; track topic; let i = $index) {
      <li id="mach-core-flyout-search-popular-item-{{ i }}">
        <a
          class="text-label-sm-semibold text-link"
          draggable="false"
          [attr.href]="topic.populartopicsLink"
          [innerHTML]="topic.populartopicsTitle"
          (click)="getSelectedValue(topic.populartopicsLink)"
          id="mach-core-flyout-search-popular-link-{{ i }}"
        ></a>
      </li>
    }
  </ul>
</div>
